module.exports = __webpack_public_path__ + "static/media/general-icons.1c4d7d64aeef9e2e8fd32f6bc1fc9287a2fc120777eea558a107876494651af2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/core/icons/general-icons.woff
// module id = 2364
// module chunks = 204